<section class="app-wha-tod">
  <h2
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
    [delay]="'100'"
    class="app-wha-tod--h2 app-title text-center navy-blue"
  >
    Co zrobić by wygrać?
  </h2>

  <div class="container app-wha-tod__con">
    <ul class="list-unstyled p-0 app-wha-tod__con__ul">
      <li
        class="app-wha-tod__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'100'"
      >
        <figure class="m-0 app-wha-tod__con__ul__li__fi">
          <img
            ngSrc="assets/images/what-todo/first.svg"
            alt="first"
            width="153"
            height="111"
            priority="false"
            class="app-wha-tod__con__ul__li__fi--img"
          />
          <figcaption class="app-wha-tod__con__ul__li__fi__fig">
            <span class="app-wha-tod__con__ul__li__fi__fig--num"> 1 </span>
            <p class="app-wha-tod__con__ul__li__fi__fig--hin">KUP</p>
            <p class="app-wha-tod__con__ul__li__fi__fig--p">
              1x dowolny produkt <span class="d-inline d-md-none">Foxy</span>
              <img
                ngSrc="assets/images/logo_foxy.webp"
                alt="logo foxy"
                width="400"
                height="268"
                priority="false"
                class="app-wha-tod__con__ul__li__fi__fig--p--img d-none d-md-block"
              />
              <br />
              i zachowaj dowód zakupu
            </p>
          </figcaption>
        </figure>
      </li>
      <li
        class="app-wha-tod__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'400'"
      >
        <figure class="m-0 app-wha-tod__con__ul__li__fi">
          <img
            ngSrc="assets/images/what-todo/second.svg"
            alt="second"
            width="71"
            height="122"
            priority="false"
            class="app-wha-tod__con__ul__li__fi--img"
          />
          <figcaption class="app-wha-tod__con__ul__li__fi__fig">
            <span class="app-wha-tod__con__ul__li__fi__fig--num"> 2 </span>
            <p class="app-wha-tod__con__ul__li__fi__fig--hin">WYPEŁNIJ</p>
            <p class="app-wha-tod__con__ul__li__fi__fig--p">
              formularz i sprawdź czy <br />
              pod e-zdrapką kryje się nagroda
            </p>
          </figcaption>
        </figure>
      </li>
      <li
        class="app-wha-tod__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'700'"
      >
        <figure class="m-0 app-wha-tod__con__ul__li__fi">
          <img
            ngSrc="assets/images/what-todo/third.svg"
            alt="third"
            width="117"
            height="104"
            priority="false"
            class="app-wha-tod__con__ul__li__fi--img"
          />
          <figcaption class="app-wha-tod__con__ul__li__fi__fig">
            <span class="app-wha-tod__con__ul__li__fi__fig--num"> 3 </span>
            <p class="app-wha-tod__con__ul__li__fi__fig--hin">
              WYGRYWAJ CODZIENNIE <br />CZEKI BLIK
            </p>
            <p class="app-wha-tod__con__ul__li__fi__fig--p">
              Gotówka do wypłaty <br />
              w każdym bankomacie!
            </p>
          </figcaption>
        </figure>
      </li>
    </ul>

    <button
      (click)="navigationClick.emit(SectionType.LOTTERY_ENTRY)"
      [aos]="0.2"
      [appAnimate]="'landing'"
      [delay]="'100'"
      [once]="true"
      [speed]="'fast'"
      class="app-wha-tod__con--btn app-btn app-btn--transparent px-lg-5"
    >
      BIORĘ UDZIAŁ
    </button>
  </div>

  <p
    class="app-wha-tod--p text-center"
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
    [delay]="'100'"
  >
    <span>
      Nie zapomnij! Zakup produktu i zgłoszenie do Loterii od 15.09.2025 r. do
      15.11.2025 r.
    </span>
  </p>
</section>
